export default "__VITE_ASSET__CYtN7QBV__"